import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import { ActivatedRoute, CanActivate, Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../../services/auth/auth.service';
import { WindowService } from '../../../services/window/window.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../../datamodel/user';
import { ToggleService } from '../../../services/toggle/toggle.service';
import { Institution } from '../../../modules/datamodel/institution';
import { Provider } from '../../../modules/datamodel/provider';

function mapSnapshot(changes: any) {
    return changes.map(a => {
        const data = a.payload.doc.data() as User;
        const id = a.payload.doc.id;
        return { id, ...data };
    });
}

@Component({
    selector: 'app-doctor-profile',
    templateUrl: './doctor-profile.component.html',
    styleUrls: ['./doctor-profile.component.scss'],
    providers: [WindowService]
})
export class DoctorProfileComponent implements OnInit {
    tab = 1;
    setTab(newTab) {
        this.tab = newTab;
    };
    isSet = function (tabNum) {
        return this.tab === tabNum;
    };

    intab = 1;
    insetTab(innewTab) {
        this.intab = innewTab;
    };
    inisSet = function (intabNum) {
        return this.intab === intabNum;
    };

    activeId: string;
    public providerProfile: object;

    private providerRef: AngularFirestoreCollection<any>;
    obsProvider: Observable<any>;

    public objAvail: object;
    public providerPhoto: string;

    private shiftProvidersRef: AngularFirestoreCollection<any>;
    obsShiftProviders: Observable<any>;

    private notificationsRef: AngularFirestoreCollection<any>;
    obsNotifications: Observable<any>;
    
    public scheduleLogs = [];
    public schedulePendingLogs = [];
    public scheduleAcceptedLogs = [];
    public scheduleDeniedLogs = [];

    constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, public toggle: ToggleService, private router: Router, public route: ActivatedRoute) {

    }

    getProviderProfile(pid) {
        const document: AngularFirestoreDocument<any> = this.afs.doc('providers/' + pid);
        const document$: Observable<any> = document.valueChanges();
        document$.subscribe(data => {
            if (!data) {
                data = {};
            }
            if (data.photo && typeof data.photo !== "undefined" && data.photo !== "") {
                this.providerPhoto = data.photo;
            } else {
                data.photo = "../../assets/img/provider.png";
                this.providerPhoto = "../../assets/img/provider.png";
            }
            if (typeof data.availability == "undefined" || data.availability == {}) {
                data.availability = {
                    sun: "",
                    mon: "",
                    tue: "",
                    wed: "",
                    thu: "",
                    fri: "",
                    sat: ""
                }
            }
            this.providerProfile = data;
        });
    }

    getProviderLogs(pid) {
        let self = this;
        self.scheduleLogs = [];
        self.schedulePendingLogs = [];
        self.scheduleAcceptedLogs = [];
        self.scheduleDeniedLogs = [];
        let l = 1;
        let lp = 1;
        let la = 1;
        let ld = 1;
        self.shiftProvidersRef = self.afs.collection('providers_schedules', ref => ref.where('provider_id', '==', pid).where('swap_request', '==', true).orderBy('day', 'asc'));
        self.shiftProvidersRef.snapshotChanges().map(mapSnapshot).subscribe(schedules => {
            if (schedules && schedules.length > 0) {
                schedules.forEach(schedule => {
                    console.log(schedule);
                    // schedule.provider_ref.get().then(doc => {
                    //     if (doc.exists) {
                    //find the details from the notifications
                    self.notificationsRef = self.afs.collection('notifications', ref => ref.where('provider_schedule_id', '==', schedule.id));
                    self.notificationsRef.snapshotChanges().map(mapSnapshot).subscribe(notifications => {
                        console.log(notifications);

                        if (notifications && notifications.length > 0) {
                            notifications.forEach(notification => {
                                self.scheduleLogs.push({
                                    iNum: l,
                                    shift_date: schedule.shift_date,
                                    type: notification.type,
                                    swap_status: notification.swap_status
                                });
                                l++;

                                if (notification.swap_status == "pending") {
                                    self.schedulePendingLogs.push({
                                        iNum: lp,
                                        shift_date: schedule.shift_date,
                                        type: notification.type,
                                        swap_status: notification.swap_status
                                    });
                                    lp++;
                                } else if (notification.swap_status == "accepted") {
                                    self.scheduleAcceptedLogs.push({
                                        iNum: la,
                                        shift_date: schedule.shift_date,
                                        type: notification.type,
                                        swap_status: notification.swap_status
                                    });
                                    la++;
                                } else if (notification.swap_status == "declined") {
                                    self.scheduleDeniedLogs.push({
                                        iNum: ld,
                                        shift_date: schedule.shift_date,
                                        type: notification.type,
                                        swap_status: notification.swap_status
                                    });
                                    ld++;
                                }
                            });
                        }
                    });
                });
            }
        });
    }

    dateFormat(dt) {
        dt = new Date(dt);
        let dfm = [
            dt.getFullYear(),
            ('0' + (dt.getMonth() + 1)).slice(-2),
            ('0' + dt.getDate()).slice(-2)
        ].join('-');
        return dfm;
    }

    editProvider(){
        this.router.navigate(['/add-doctor/'+this.activeId]);
    }

    ngOnInit() {
        this.objAvail = {
            "am_only": "AM Only",
            "pm_only": "PM Only",
            "full_day": "Full Day",
            "full_time": "Full Day",
            "emergency_only": "Emergency",
            "NA": "Not Available"
        };
        this.route.params.subscribe(p => {
            if (p.id) {
                this.activeId = p.id;
                this.getProviderProfile(this.activeId);
                this.getProviderLogs(this.activeId);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/doctors/doctor-profile/doctor-profile.component.ts